<div class="lists-container">
  <div class="flex-fill">
    <h6 class="text-primary py-2">
      {{ "DCO.TableConfig_AvailableColumns" | translate }}
    </h6>
    <div cdkDropList
      #notSelectedElements="cdkDropList"
      [cdkDropListData]="availableColumns"
      [cdkDropListConnectedTo]="[selectedElements]"
      class="example-list"
      (cdkDropListDropped)="drop($event)">
      @if(availableColumns.length>0){
      @for (item of availableColumns; track item) {
      <div class="grid-item"
        cdkDrag>
        <i class="fa-solid fa-grip-vertical drag"></i>
        <span class="label">{{ item.name | translate }}</span>
      </div>
      }
      } @else {
      <div class="empty-message">
        {{ "DCO.TableConfig_NoMoreColumns" | translate }}
      </div>
      }
    </div>
  </div>
  <div class="flex-fill">
    <h6 class="text-primary py-2">
      {{ "DCO.TableConfig_SelectedColumns" | translate }}
    </h6>
    <div cdkDropList
      #selectedElements="cdkDropList"
      [cdkDropListData]="selectedColumns"
      [cdkDropListConnectedTo]="[notSelectedElements]"
      class="example-list"
      (cdkDropListDropped)="drop($event)">
      
      @if(selectedColumns.length>0){
      @for (item of selectedColumns; track item) {
      <div class="grid-item checked"
        cdkDrag>
        <i class="fa-solid fa-grip-vertical drag"></i>
        <span class="label">{{ item.name | translate }}</span>
        <i class="fa-solid fa-check check"></i>
      </div>
      }
      } @else {
      <div class="empty-message">
        {{ "DCO.TableConfig_NoColumnsSelected" | translate }}
      </div>
      }
    </div>
  </div>
</div>